module.exports = __webpack_public_path__ + "fffee06a97a22f325287eb11ceba0490.png";